import { render, staticRenderFns } from "./navs.vue?vue&type=template&id=6083a0e0&scoped=true"
import script from "./navs.vue?vue&type=script&lang=js"
export * from "./navs.vue?vue&type=script&lang=js"
import style0 from "./navs.vue?vue&type=style&index=0&id=6083a0e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6083a0e0",
  null
  
)

export default component.exports